import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, filter, isEmpty } from "lodash";

import { fetchPost } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import ProfileLink from "../../Common/ProfileLink";
import ProfileSurvey from "../../Profiles/ProfileSurvey/ProfileSurvey";

import { human } from "../../../constants/common";
import { eventGroupsData } from "../../../constants/eventGroups";

import colors from "../../../assets/style/colors";
import { fetchGet } from "../../../api/fetch";
import AddVerification from "../../Profiles/AddVerification";

const LogDetailsVerificationNew = (props) => {
  const { log, language, identificationEventGroup, overriden } = props;

  const [verificationEventGroup, setVerificationEventGroup] = React.useState();
  const [surveys, setSurveys] = React.useState();

  React.useEffect(() => {
    fetchVerificationEventGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get(log, ["id"])]);

  const fetchVerificationEventGroup = async () => {
    try {
      let res = await fetchPost("new/event_groups", {
        filter: {
          parent_ids: [get(log, ["id"])],
          types: [14],
        },
        data: eventGroupsData,
      });
      setVerificationEventGroup(get(res, ["items", 0]));
    } catch (e) {
      console.log(e);
    }
  };

  React.useEffect(() => {
    getSurveys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verificationEventGroup]);

  const getSurveys = async () => {
    let preSurvey, lastSurvey, referenceSurvey;
    if (!isEmpty(verificationEventGroup)) {
      preSurvey = get(
        filter(get(verificationEventGroup, ["events"]), (e) =>
          [91].includes(get(e, ["type", "id"]))
        ),
        [0]
      );
      lastSurvey = get(
        filter(get(verificationEventGroup, ["events"]), (e) =>
          [81].includes(get(e, ["type", "id"]))
        ),
        [0]
      );
      if (get(preSurvey, ["reference_event_id"])) {
        referenceSurvey = await fetchGet(
          `events/${get(preSurvey, ["reference_event_id"])}`
        );
      }
    }
    setSurveys({
      preSurvey,
      lastSurvey,
      referenceSurvey,
    });
  };

  const onSubmitVerification = async (
    verificationEventGroup,
    surveyEvent,
    lukeActionEvent,
    verification
  ) => {
    try {
      verificationEventGroup.parent_id = get(log, ["id"]);
      let eventGroup = await fetchPost("event_groups", verificationEventGroup);
      surveyEvent.event_group_id = get(eventGroup, ["id"]);
      lukeActionEvent.event_group_id = get(eventGroup, ["id"]);
      await fetchPost("events", surveyEvent);
      await fetchPost("events", lukeActionEvent);
      fetchVerificationEventGroup();
      if (props.refreshLog) {
        props.refreshLog();
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Grid container direction="column" wrap="nowrap">
        <ProfileLink
          profile={get(identificationEventGroup, ["profile"])}
          score={get(identificationEventGroup, ["luke_index"])}
          overriden={overriden}
          type={human}
          disabled={props.blockLevel2}
        />
        <Grid
          item
          style={{
            marginTop: "20px",
            marginLeft: "30px",
          }}
        >
          <AddVerification
            profile={get(identificationEventGroup, ["profile"])}
            language={language}
            refreshHistory={fetchVerificationEventGroup}
            isMe={false}
            onSubmit={onSubmitVerification}
            noVerificationSubmit
            noConfirmation
            companies={[get(log, ["events", 0, "zone", "company", "id"])]}
            sites={[get(log, ["events", 0, "zone", "site", "id"])]}
            zones={[get(log, ["events", 0, "zone", "id"])]}
          />
        </Grid>
        <Grid
          style={{
            marginLeft: "30px",
          }}
        >
          <ProfileSurvey
            surveys={surveys}
            profileId={get(identificationEventGroup, ["profile", "id"])}
            language={language}
            eventGroupId={get(identificationEventGroup, ["id"])}
            onlyEdit={{
              onClose: () => {},
            }}
            hide={{
              new: true,
            }}
          />
        </Grid>
      </Grid>
      {props.powerUserMode && (
        <Box
          style={{
            position: "absolute",
            bottom: "82px",
            right: "56px",
            fontSize: "0.875em",
            color: colors.black38,
          }}
        >
          {I18n.get("site_eventGroupId") + " "}
          <span style={{ fontStyle: "italic" }}>
            {get(verificationEventGroup, ["id"])}
          </span>
        </Box>
      )}
    </>
  );
};

export default LogDetailsVerificationNew;
